<div style="width: 100%; height: 80vh; display: flex; align-items: center; justify-content: center;">
    <img src="../../../../assets/images/404.PNG" alt="">
</div>